<template>
    <div class="quote-list" :id="item.id">
        <div class="white-bg quote-block">
            <div class="quote-header">
                <div class="quote-header-title">
                    <div class="q-nmbr">
                        <router-link :to="{ name: 'orderShow', params: { id: item.id }}" class="quote_view">
                            #{{ item.order_number }}
                        </router-link>
                    </div>
                    <div class="item-name"></div>
                </div>
                <div class="quote-header-right"><a class="clone-btn" href="javascript:void(0)">Clone</a></div>
            </div>
            <div class="content-section">
                <div class="customer-name">
                    <b>Customer :</b> {{ item.customer ? item.customer.company_name : '' }} ,
                    ({{ item.customer && item.customer.customer_contacts && item.customer.customer_contacts.length ? item.customer.customer_contacts[0].contact_name : '' }}) </div>

            </div>

            <div class="quote-footer">
                <div class="user-name"><b>Added By: </b> {{ item.added_by ? item.added_by.name : '' }}</div>
                <div class="quote-date"><b>Created  </b> {{ item.created_at }} <b>Updated  </b> {{ item.uodated_at }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrderGridItem",
    props: ['item', 'bus',],
    mounted() {
    },
    methods: {
        formatStatusClass(item) {
            if(item.status) {
                return item.status.name.replace(" ", "-").replace("/", "-").toLowerCase();
            }
            return "";
        }
    }
}
</script>

<style scoped>

</style>
